import React from "react";
import { useGetTargetsUrl } from "hooks";
import { CommonQuicksightDashboard } from "../components";

export const TargetsTab = () => {
  const { data: targetsResponse, isLoading: isLoadingTargets } = useGetTargetsUrl();

  return (
    <CommonQuicksightDashboard
      title="Targets"
      embedUrl={targetsResponse?.embedUrl ?? ""}
      isLoading={isLoadingTargets}
    />
  );
};